import { withCurrentParams } from '../utils';
import {
  BROADCAST_KNOCK_MEETING,
  BROADCAST_KNOCK_MEETING_ASYNC
} from '../Types';
import { PENDING, PRESENTER_KNOCK } from 'constants/Knock';
import { NO_DEVICE_FOUND, PERMISSION_DENIED } from 'constants/ReadinessCheck';
/**
 * This creates the action to create a knock to join a meeting,
 * The reason we're using isTransient is to distinguish when to make an API call or not
 * And this is solely because this same action creator is also used to update a
 * knock (in the resulting AV modal when a knock has been approved or answered)
 */
function knock({
  presenterName,
  isTransient,
  presenterDescription,
  presenterDetailsUpdated,
  sessionId,
  presenterPhoto
}) {
  return withCurrentParams(
    (dispatch, { teamId, eventId, broadcastId }, getState) => {
      const actionType = isTransient
        ? BROADCAST_KNOCK_MEETING_ASYNC
        : BROADCAST_KNOCK_MEETING;

      const { user, readinessCheck } = getState();
      const userId = user?._id;
      const description = presenterDescription || user?.title || '';
      const { camera } = readinessCheck || {};
      const cameraUnavailable =
        camera === NO_DEVICE_FOUND || camera === PERMISSION_DENIED;
      const request = async apiClient => {
        const payload = {
          name: presenterName,
          status: PENDING,
          type: PRESENTER_KNOCK,
          presenterPhoto,
          userId,
          description,
          cameraUnavailable
        };

        if (sessionId) {
          payload.sessionId = sessionId;
        }

        const { broadcast, ...restKnockData } =
          await apiClient.broadcastKnock.createKnockRequest(
            teamId,
            eventId,
            broadcastId,
            payload
          );
        // normalize knock
        return {
          broadcastId: broadcast,
          ...restKnockData,
          description,
          presenterDetailsUpdated,
          sessionId,
          userId
        };
      };

      const payload = {
        broadcastId,
        name: presenterName,
        description,
        presenterDetailsUpdated,
        presenterPhoto,
        userId
      };

      const action = {
        type: actionType,
        ...(isTransient ? { request } : { payload })
      };

      dispatch(action);
    }
  );
}

export default knock;
